<template>
    <div class="grid grid-cols-7 gap-3 pt-5">
        <NextButton class="col-start-2" component="router-link" :to="{name:'ListaUtenti'}">Utenti</NextButton>
        <NextButton component="router-link" :to="{name:'ListaRuoli'}">Gruppi</NextButton>
        <NextButton component="router-link" :to="{name:'ListaPermessi'}">Permessi</NextButton>
        <NextButton component="router-link" :to="{name:'ListaAziendeGruppo'}">Aziende</NextButton>
        <NextButton component="router-link" :to="{name:'BusinessUnits'}">Business Unit</NextButton>
        <NextButton component="router-link" class="col-start-2" :to="{name:'VociSpesaBusinessUnitsIva'}">IVA predefinita</NextButton>
        <NextButton component="router-link" class="" :to="{name:'LoginNinja'}">Login ninja</NextButton>
        <NextButton component="router-link" class="" :to="{name:'AttivitaTimesheet'}">Attività timesheet</NextButton>
        <NextButton component="router-link" class="" :to="{name:'BilanciPrevisionali'}">Previsionale commerciale</NextButton>
    </div>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {mapGetters} from 'vuex';
import NextButton from "@/components/NextButton.vue";
import Timesheet from "@/router/timesheet";

@Options({
    name: 'HomePermessi',
    components: {
        Timesheet,
        NextButton
    },
    computed: {
        ...mapGetters([
            'me',
        ])
    }
})
export default class HomePermessi extends Vue {

}

</script>


<style lang="scss">

</style>
